export const LOGO = "https://customer-assets.emergentagent.com/job_b0fac175-ce9a-4e03-911e-6c08ae2e7b2d/artifacts/7ai4ypni_elenem_strategies_logo.jpg";

export const IMG = {
  heroMountain: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/xn1isv0r_lnm2.webp",
  aboutUn: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/09lhxnzc_lnmp15.jpg",
  aboutSmile: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/1vud8i5b_lnmp8.jpg",
  speaking: "https://customer-assets.emergentagent.com/job_b0fac175-ce9a-4e03-911e-6c08ae2e7b2d/artifacts/y3pn00bi_lnmp17.jpg",
  speakingWood: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/lc5tvo6s_lnmp16.webp",
  flags: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/rrxk1sg0_lnmp13.jpg",
  skydive: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/b62kelrb_lnm8.jpg",
  confidence: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/5ipz163i_lnmp11.jpg",
  panel: "https://customer-assets.emergentagent.com/job_b0fac175-ce9a-4e03-911e-6c08ae2e7b2d/artifacts/2wceeu4i_lnmp9.jpg",
  group: "https://customer-assets.emergentagent.com/job_b0fac175-ce9a-4e03-911e-6c08ae2e7b2d/artifacts/dleadz66_lnmp10.jpg",
  conference: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/09lhxnzc_lnmp15.jpg",
  glacier: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/57o6izuz_lnm5.webp",
  morocco: "https://customer-assets.emergentagent.com/job_consult-launch-7/artifacts/3uqw7i3j_lnm9.jpg",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Curious About Elenem", to: "/about" },
  { label: "Meet the Consultant", to: "/meet" },
  { label: "Explore Our Services", to: "/services" },
  { label: "Explorations in Action", to: "/work" },
  { label: "Collaborate", to: "/collaborate" },
];

// Obfuscated email — assembled at runtime so it doesn't appear in raw HTML source
export const EMAIL_PARTS = ["leah", "elenemstrategies.com"];
export const getEmail = () => `${EMAIL_PARTS[0]}@${EMAIL_PARTS[1]}`;
export const getMailto = () => `mailto:${getEmail()}`;
export const SCHEDULE_URL = "https://calendar.app.google/sdtkHgv3AHvTFggz9";
